<template>
  <div>
    <el-table
      :data="tableData"
      class="p-table"
      stripe
      border
      size="mini"
      style="width: 100%"
    >
      <el-table-column
        prop="createdAt"
        label="Data"
        min-width="180"
        align="center"
        width="150"
        :formatter="formatarData"
      >
      </el-table-column>
      <el-table-column
        prop="tipoRelatorio.description"
        label="Tipo do relatório"
        min-width="180"
      >
      </el-table-column>
      <el-table-column
        prop="status.description"
        label="Status"
        width="130"
        align="center"
      >
        <template slot-scope="scope">
          <el-tag
            style="width:100px"
            :type="colorTag(scope.row.status)"
            disable-transitions
          >
            {{ scope.row.status.description }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        label="Ação"
        align="center"
        width="150"
      >
        <template slot-scope="scope">
          <el-tooltip
            class="item"
            v-if="temAcesso('Relatorio','Exportar') && premiumUser()"
            effect="dark"
            :content="scope.row.status && scope.row.status.value !== 2  ? 'É necessário aguardar o status de finalizado' : 'Download disponível'"
            placement="left-end"
          >
            <span>
              <el-button
                type="primary"
                size="mini"
                :loading="loadingDownload[scope.row._id || '0']"
                :disabled="scope.row.status.value !== 2"
                @click="download(scope.row)"
              >
                <i class="el-icon-download el-icon-right"></i> Download
              </el-button>
            </span>
          </el-tooltip>
          <el-button v-else size="mini" disabled class="no-drop">
            <i class="el-icon-download el-icon-right"></i> Download
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-footer class="text-center" style="padding-top: 20px;">
      <el-button
        class="float-right"
        circle
        @click="atualizarDadosTabela"
        style="position: absolute; bottom: 5px; right: 15px;"
      >
        <i class="fas fa-sync-alt"></i>
      </el-button>
    </el-footer>
  </div>
</template>

<script>
import moment from "moment";

const statusArquivo = {
  0: "warning",
  1: "primary",
  2: "success",
  3: "danger",
};

export default {
  name: "RelatorioTable",
  props: {
    filtros: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      tableData: [],
      loadingDownload: {},
    };
  },
  methods: {
    formatarData(value) {
      return this.moment(value.updatedAt).format("DD/MM/YYYY hh:mm");
    },
    colorTag(data) {
      return statusArquivo[data.value];
    },
    async atualizarDadosTabela(filtros = {}) {
      this.loading = true;

      const filtrosAjustados = {
        ...filtros,
        origem: filtros.origem && filtros.origem.length > 0 ? filtros.origem : undefined,
        dataSolicitacaoInicio: filtros.dataSolicitacaoInicio
          ? moment(filtros.dataSolicitacaoInicio).format("YYYY-MM-DD")
          : undefined,
        dataSolicitacaoFinal: filtros.dataSolicitacaoFinal
          ? moment(filtros.dataSolicitacaoFinal).format("YYYY-MM-DD")
          : undefined,
      };

      try {
        const { data } = await this.axios.get(this.$urls.RELATORIO_LIST, {
          params: filtrosAjustados,
          // Personalizando a serialização dos parâmetros
          paramsSerializer: (params) => {
            return Object.entries(params)
              .map(([key, value]) => {
                if (Array.isArray(value)) {
                  // Serializar o array no formato desejado sem codificação de colchetes
                  return `${key}=${value.join(",")}`;
                } else if (value !== undefined && value !== null) {
                  return `${key}=${value}`;
                }
                return null;
              })
              .filter(Boolean)
              .join("&");
          },
        });
        this.tableData = data;
      } catch (error) {
        console.error("Erro ao buscar dados:", error);
      } finally {
        this.loading = false;
      }
    },
    download(param) {
      this.$set(this.loadingDownload, param._id || "0", true);

      this.requestDownload(param._id);
    },
    callbackDownload(id) {
      this.$set(this.loadingDownload, id, false);
      this.$message.success("Download concluído.");
    },
    async requestDownload(id) {
      try {
        await this.$blob.getDownload(
          `${this.$urls.RELATORIO_DOWNLOAD}/${id}`,
          this.callbackDownload.bind(this, id)
        );
      } catch (error) {
        console.error("Erro na solicitação de download:", error);
        throw error;
      } finally {
        this.$set(this.loadingDownload, id, false);
      }
    },
  },
  watch: {
    filtros: {
      deep: true,
      immediate: true,
      handler(novosFiltros) {
        this.atualizarDadosTabela(novosFiltros);
      },
    },
  },
  created() {
    this.atualizarDadosTabela();
  },
};
</script>
